import React, { Fragment, useContext, useState } from "react";
import {
  Disabled,
  FirstName,
  Heading4,
  LastName,
  Phone,
} from "../../../../../../Constant";
import { Btn, H5, H6, P } from "../../../../../../AbstractElements";
import {
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Button,
  CardTitle,
  Card,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import CustomizerContext from "../../../../../../_helper/Customizer";
import {
  AddPatientPrescriptionPayment,
  EditPatientPrescriptionPayment,
} from "../../../../../../apiController";
import { toast } from "react-toastify";

const CheckoutTableData = () => {
  const { layoutURL } = useContext(CustomizerContext);
  const history = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [edit, setEdit] = useState(false);

  const handleBack = () => {
    history(`${process.env.PUBLIC_URL}/billing/${layoutURL}`);
  };

  const location = useLocation();
  const { rowData, data, permission } = location.state || {};

  console.warn( rowData);

  const onSubmit = (formdata) => {
    console.log(formdata);
    console.log(data);
    // const id =
    const formattedData = {
      date: rowData.date,
      prescription_id: rowData.prescription.map((prep) => prep.id),
      patient_id: data.id,
      paid_amt: formdata.amount,
      total_amt: rowData.sum,
      status: formdata.status,
    };

    console.log(formattedData);

    if (edit) {
      const updateFormattedData = {
        ...formattedData,
        id: rowData.prescription[0]["prescription_payment_id"],
      };
      updatePrescriptionPayment(updateFormattedData);
    } else {
      createPrescriptionPayment(formattedData);
    }
  };

  const createPrescriptionPayment = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await AddPatientPrescriptionPayment(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      history(`/patientinfo/prescription`, { state: { data, rowData } });
    }
  };
  const updatePrescriptionPayment = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await EditPatientPrescriptionPayment(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      setEdit(!edit);
      history(`/patientinfo/prescription`, { state: { data, rowData } });
    }
  };

  const handleView = (dtls) => {
    history(`/patientinfo/prescription`, { state: { data, rowData, dtls } });
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    setValue
  } = useForm();

  const amount = watch("amount", 0);
  const handleAmountChange = (event) => {
    const value = parseFloat(event.target.value);
    
    // Check if value is greater than rowData.sum or not a number
    if (value <= rowData.sum || isNaN(value)) {
      setValue("amount", value);
    }
  };

  return (
    <Fragment>
      <Col xl="6" sm="12" className=" pb-4">
        <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <Row>
            <FormGroup className="mb-3 col-sm-6 text-primary">
              <Label className="text-secondary">{FirstName}</Label>
              <H5>{data.first_name}</H5>
              {/* <input className="form-control" type="text" name="firstName" {...register('firstName', { required: false })} />
                            <span style={{ color: '#ff5370' }}>{errors.firstName && 'First name is required'}</span> */}
            </FormGroup>
            <FormGroup className="mb-3 col-sm-6 text-primary">
              <Label className="text-secondary">{LastName}</Label>
              <H5>{data.surname}</H5>
              {/* <input className="form-control" type="text" name="firstName" {...register('firstName', { required: false })} />
                            <span style={{ color: '#ff5370' }}>{errors.firstName && 'First name is required'}</span> */}
            </FormGroup>
          </Row>
          <Row>
            <FormGroup className="mb-3 col-sm-6">
              <Label className="text-secondary">{Phone}</Label>
              <H6>{data.phone}</H6>
              {/* <input className="form-control" type="number" name="phone" {...register('phone', { required: false })} />
                            <span style={{ color: '#ff5370' }}>{errors.phone && 'Please enter number for phone.'}</span> */}
            </FormGroup>
            {/* <FormGroup className="mb-3 col-sm-6">
                            <Label>{'Treatment'}</Label>
                            <H6>{'Orthopedic Appliances'}</H6>
                        </FormGroup> */}
          </Row>
          <Row>
            <Table bordered striped>
              <thead>
                <tr>
                  <th className="item">Prescription Name</th>
                  <th className="Rate">M-A-E-N</th>
                  <th className="intake">In-Take</th>
                  <th className="quantity">Quantity</th>
                  <th className="duration">Duration</th>
                </tr>
              </thead>
              <tbody>
                {rowData.prescription &&
                  rowData.prescription.map((prep, index) => (
                    <tr key={index}>
                      <td>
                        <Label>{prep.sub_name}</Label>
                      </td>
                      <td>
                        <P attrPara={{ className: "itemtext digits" }}>
                          {`${prep.morning === "yes" ? 1 : 0}-${
                            prep.afternoon === "yes" ? 1 : 0
                          }-${prep.evening === "yes" ? 1 : 0}-${
                            prep.night === "yes" ? 1 : 0
                          }`}
                        </P>
                      </td>
                      <td>
                        <P attrPara={{ className: "itemtext digits" }}>
                          {prep.after_food === null
                            ? prep.before_food === "yes"
                              ? "Before-food"
                              : "-"
                            : prep.after_food === "yes"
                            ? "After-food"
                            : "-"}
                        </P>
                      </td>
                      <td className="payment digits">
                        <P attrPara={{ className: "itemtext digits" }}>
                          {prep.quantity}
                        </P>
                      </td>
                      <td className="payment digits">
                        <P attrPara={{ className: "itemtext digits" }}>
                          {prep.duration}
                        </P>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Row>

          {/* <FormGroup className="mb-3">
            <Form.Check
              type="switch"
              className="warning"
              color="warning"
              checked={edit}
              onChange={() => setEdit(!edit)}
            />
            
          </FormGroup> */}

          {permission?.edit_access && <FormGroup switch>
            <Input
              type="switch"
              checked={edit}
              onClick={() => {
                setEdit(!edit);
              }}
            />
            <Label check>Edit Last Transaction Amount</Label>
          </FormGroup>}

          {edit && (
            <>
              <FormGroup className="mb-3">
                <Label for="amount">Last Transaction Amount</Label> <br />
                <h5>
                  {rowData.prescription[0]["paid_amt"]
                    ? rowData.prescription[0]["paid_amt"]
                    : "-"}
                </h5>
              </FormGroup>
            </>
          )}
          <FormGroup className="mb-3">
            <Label for="amount">Enter Amount</Label>
            <input
              className="form-control"
              type="number"
              name="amount"
              min="0"
              step="0.01"
              onChange={handleAmountChange}
              {...register("amount", {
                required: false,
                validate: (value) => {
                  return value <= rowData.sum || "Amount cannot exceed total available amount.";
                }
              })}
              />
              {amount > rowData.sum && (
                <p className="text-danger">Amount cannot exceed total available amount.</p>
              )}
            <span style={{ color: "#ff5370" }}>
              {errors.amount && "Please enter Valid Amount"}
            </span>
          </FormGroup>
          {/* {!edit && <FormGroup className="mb-3">
            <Label for="amount">{"Enter Amount"}</Label>
            <input
              className="form-control"
              type="number"
              name="amount"
              min="0"
              step="0.01"
              {...register("amount", { required: true })}
            />
            <span style={{ color: "#ff5370" }}>
              {errors.amount && "Please enter Amount"}
            </span>
          </FormGroup>} */}
          <FormGroup className="mb-3">
            <Label for="status">{"Enter Status"}</Label>
            <input
              className="form-control"
              type="text"
              name="status"
              {...register("status", { required: true })}
            />
            <span style={{ color: "#ff5370" }}>
              {errors.status && "Please enter Status"}
            </span>
          </FormGroup>
          <div>
            <div className="text-end">
            {permission?.create_access &&   <Button
                className="success m-2"
                type="submit"
                disabled={isSubmitting}
                color="success"
              >
                {isSubmitting ? "Submitting..." : "Pay Now"}
              </Button>}
              <Button
                className="success"
                type="submit"
                onClick={() => handleView(rowData)}
                color="primary"
              >
                {"Cancel"}
              </Button>
            </div>
          </div>
        </Form>
      </Col>
    </Fragment>
  );
};
export default CheckoutTableData;
